import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { ChannelService } from 'common/data';

class ChannelStore extends BaseStore {
	constructor(rootStore) {
		super(new ChannelService(rootStore.app.baasic.apiClient));
	}

	@action
	findChannel = async filter => {
		const response = await this.service.find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	};

	@action
	getChannel = async (id, options) => {
		const channel = await this.service.get(id, options);
		this.item = channel.data;
		return channel.data;
	};

	@action
	updateChannel = async (channel, sourceOfChange) => {
		await this.service.update(channel, sourceOfChange);
	};

	@action
	createChannel = async (channel, sourceOfChange) => {
		await this.service.create(channel, sourceOfChange);
	};

	@action
	deleteChannel = async channel => {
		await this.service.delete(channel);
	};

	@action
	authorizeAmazon = async oAuthDate => {
		await this.service.authorizeAmazon(oAuthDate);
	};

	@action
	getAuthorizationResultAmazon = async state => {
		const oAuthResult = await this.service.authorizationResultAmazon(state);
		return oAuthResult.data;
	};

	@action
	updateChannelWarehouseCodes = async (updateChannelWarehouseCodesParams, sourceOfChange) => {
		const response = await this.service.updateChannelWarehouseCodes(updateChannelWarehouseCodesParams, sourceOfChange);
		return response.data;
	};

	@action
	updateChannelCustomLabel = async (updateChannelCustomLabelParams, sourceOfChange) => {
		const response = await this.service.updateChannelCustomLabel(updateChannelCustomLabelParams, sourceOfChange);
		return response.data;
	};
}

export default ChannelStore;



// WEBPACK FOOTER //
// ./src/modules/channel/stores/ChannelStore.js